import { jsx as _jsx } from "react/jsx-runtime";
import { ListItem } from '../ListItem';
import { TextInputField } from '../TextInputField';
import { MenuList } from '../MenuList';
import { useSingleFilterableListBase, FilterableListBaseFieldTrailingIcon, } from '../FilterableListBase';
import { FloatingFilterableListBase } from '../FloatingFilterableListBase';
import { fixedForwardRef } from '../../helpers/fixedForwardRef';
export const SuggestBase = fixedForwardRef(function SuggestBase(props, forwardedRef) {
    const { sx, styles, items, itemRenderer, itemLabel, selectedItem, defaultItem, itemEmpty, onItemChange, getValueFieldProps, clearable, variant, noResults, placeholder, ...other } = props;
    const singleFilterableListBase = useSingleFilterableListBase({
        items,
        itemRenderer,
        selectedItem,
        defaultItem,
        itemEmpty,
        itemsEqual: other.itemsEqual,
        onItemChange,
    });
    const selectedItemLabel = singleFilterableListBase.selectedItem
        ? itemLabel(singleFilterableListBase.selectedItem)
        : undefined;
    return (_jsx(FloatingFilterableListBase, { items: singleFilterableListBase.items, onItemSelect: singleFilterableListBase.handleItemSelect, renderer: (listProps) => (_jsx(MenuList, { noFocusRing: true, cols: listProps.filteredItems.length > 0 ? other.cols : undefined, children: listProps.filteredList })), itemRenderer: singleFilterableListBase.itemRenderer, matchTargetWidth: true, resetOnSelect: true, resetOnClose: true, resetOnBlur: true, closeOnSelect: true, initialFocus: -1, ...other, forwardProps: true, noResults: noResults ?? _jsx(ListItem, { disabled: true, children: "No results." }), ref: forwardedRef, children: (renderProps) => (_jsx(TextInputField, { trailingIcon: _jsx(FilterableListBaseFieldTrailingIcon, { onClear: clearable &&
                    singleFilterableListBase.selectedItem &&
                    !itemEmpty?.(singleFilterableListBase.selectedItem)
                    ? (event) => singleFilterableListBase.handleClear(renderProps.afterItemsRemove, event)
                    : undefined, opened: renderProps.opened }), populated: renderProps.opened ||
                !!singleFilterableListBase.selectedItem ||
                !!renderProps.query, ...renderProps.forwardedProps, ...renderProps.getInputFilterProps(renderProps.getTriggerProps()), value: renderProps.opened || renderProps.hasFocus
                ? renderProps.query
                : ((typeof selectedItemLabel === 'string'
                    ? selectedItemLabel
                    : undefined) ?? ''), placeholder: (renderProps.opened || renderProps.hasFocus) && selectedItemLabel
                ? typeof selectedItemLabel === 'string'
                    ? selectedItemLabel
                    : undefined
                : placeholder, variant: variant, ...getValueFieldProps?.(renderProps, singleFilterableListBase.selectedItem), sx: sx, styles: styles, containerRef: renderProps.setTriggerRef, inputRef: renderProps.inputFilterRef, spellCheck: 'false', autoComplete: 'off' })) }));
});
